<template>
  <div class="common-layout">
    <el-container>
      <el-header v-show="this.isManage">
        <el-row>
          <el-col :span="24">
            <el-menu
              class="el-menu-demo"
              mode="horizontal"
              :ellipsis="false"
            >
              <el-menu-item index="0">
                <img src="../src/assets/images/logo.png" alt="img" class="logo" />
              </el-menu-item>
              <div class="flex-grow"/>
              <el-menu-item v-for=" item in routesDetail " :index="item.key" :key="item.key" @click="handlePagePath">
                <router-link :to=" item.path ">{{ item.meta.title }}</router-link>
              </el-menu-item>
            </el-menu>
            <div class="versionSwitch">
              <router-link to="/cn/cn_Home">
                <img src="../src/assets/images/lang_cn.png" alt="img" class="lang" />
                <el-button link @click="cx_i18n('/cn')">CN</el-button>
              </router-link> | 
              <router-link to="/en/en_Home">
                <img src="../src/assets/images/lang_en.png" alt="img"  class="lang"/>
                <el-button link @click="cx_i18n('/en')" >EN</el-button>
              </router-link>
              <!-- <router-link to="/manage/mg_Login"></router-link> -->
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-container>
          <el-main>
            <el-carousel height="350px" v-show="this.isManage && !isProduct">
              <el-carousel-item v-for="item in 1" :key="item">
                <h3 class="small justify-center" text="2xl" style="margin: 0;">
                  <!-- <img :src="require('../src/assets/images/banner/banner_0' + (item + 4)*1 + '.png')" alt="img" class="bannerImg"/> -->
                  <img :src="require('../src/assets/images/banner/banner_08.png')" alt="img" class="bannerImg"/>
                </h3>
              </el-carousel-item>
            </el-carousel>
            <router-view></router-view>
          </el-main>
          <!-- <el-footer>Footer</el-footer> -->
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import routes from '../src/router/setRoutes';

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      routesDetail: routes.filter( e => e.path === '/cn')[0].children,
      isManage: true,
      isProduct: false
    }
  },
  created() {
    this.initDetail();
    this.getisManage();
  },
  mounted() {
  },
  methods: {
    getisManage () {
      let _UrlPath = window.location.href;
      if ( _UrlPath.indexOf('manage') >= 0 ) {
        this.isManage = false;
      } else {
        this.isManage = true;
      }
    },
    initDetail () {
    },
    cx_i18n ( type ) {
      this.routesDetail = routes.filter( e => e.path === type)[0].children;
    },
    handlePagePath(){
      console.log('handlePagePath');
      this.isProduct = window.location.hash.indexOf('Products') !== -1
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.logo {
  width:10em;
  height: 3em;
  margin: 0.5em;
}
.lang {
  width:1em;
  height: 0.7em;
  margin: 0.5em 0.5em 0em;
}
.versionSwitch{
  position: absolute;
  right: 0;
  top: 0;
  padding:0.5em;
}
.bannerImg{
  width: 100%;
}
</style>
